export default __webpack_public_path__ + "static/media/imgPlaceholder.74005af1.svg";